import { render } from "./VHeader.vue?vue&type=template&id=141d29ea&scoped=true"
import script from "./VHeader.vue?vue&type=script&lang=js"
export * from "./VHeader.vue?vue&type=script&lang=js"

import "./VHeader.vue?vue&type=style&index=0&id=141d29ea&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141d29ea"]])

export default __exports__